import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { ContextStore } from 'bernie-core';
import { LocalizedText } from 'bernie-l10n';

import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';

import { ButtonType } from 'constants/button-types.ts';
import { RoomViewModel } from 'src/common/models';

import { UitkPrimaryButton, UitkTertiaryButton } from 'uitk-react-button';

const ButtonTracked = ClickTracker(UitkPrimaryButton);
const TertiaryButtonTracked = ClickTracker(UitkTertiaryButton);

export interface ReserveButtonProps {
  currentHotel?: CurrentHotelStore;
  context?: ContextStore;
  dataAttributes?: Record<string, unknown>;
  description?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  label?: string;
  onUserClick?: (e) => any;
  option?: number;
  rfrr?: string;
  roomPosition?: string;
  ratePlanCode?: string;
  room?: RoomViewModel;
  buttonType?: ButtonType;
  innerRef?: (ref) => void;
}

export const ReserveButton: React.FunctionComponent<ReserveButtonProps> = ({
  dataAttributes = {},
  description,
  disabled = false,
  fullWidth,
  label,
  onUserClick,
  option,
  rfrr,
  roomPosition,
  ratePlanCode,
  buttonType,
  innerRef,
}) => {
  const commonButtonProps = {
    ...dataAttributes,
    'data-stid': buttonType === ButtonType.SECONDARY ? 'add-to-cart' : 'submit-hotel-reserve',
    type: 'submit',
    disabled,
    linkName: 'Book selected room choice',
    className: 'uitk-button-new-primary',
    trackImmediate: true,
    isFullWidth: fullWidth,
    domRef: innerRef,
  };

  const ButtonComponent = buttonType === ButtonType.TERTIARY ? TertiaryButtonTracked : ButtonTracked;

  return (
    <ButtonComponent
      {...commonButtonProps}
      rfrr={rfrr ? rfrr : `RoomsAndRates.BookButton.Room${roomPosition}.Rate${option}.${ratePlanCode}`}
      text={
        <ButtonText
          label={label || <LocalizedText message="hotels.infosite.ratePlan.bookButton.label" />}
          description={description || <LocalizedText message="hotels.infosite.ratePlan.bookButton.label" />}
        />
      }
      onClick={onUserClick}
    />
  );
};

ReserveButton.displayName = 'ReserveButton';

const ButtonText = ({ label, description }) => (
  <>
    {label}
    {description && <span className="is-visually-hidden">{description}</span>}
  </>
);
